import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import { AUTH_TOKEN } from '@/constants';
import authRoutes from '@/modules/auth/router';
import agentRoutes from '@/modules/admin/agent/router';
import verifierRoutes from '@/modules/admin/verifier/router';
import { store } from '@/store'; // Ensure your store is properly imported
import i18n from '@/i18n';

const notAuth = () =>
  import(/* webpackChunkName: "notAuthorized" */ '@/views/NotAuthorized.vue');

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:lang',
    name: 'locale',
    redirect: { name: 'login' },
    children: [
      {
        path: 'not-authorized',
        name: 'not-authorized',
        component: notAuth,
      },
      ...authRoutes,
      ...agentRoutes.map((route) => ({
        ...route,
        meta: { requiresAuth: true, role: 'agent' },
      })),
      ...verifierRoutes.map((route) => ({
        ...route,
        meta: { requiresAuth: true },
      })),
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach(async (to, from, next) => {
  const token = window.localStorage.getItem(AUTH_TOKEN);

  // Redirect to default language if missing
  if (!to.params.lang) {
    const defaultLanguage = process.env.VUE_APP_DEFAULT_LOCALE || 'pt';
    return next({ name: 'locale', params: { lang: defaultLanguage } });
  }

  // Set current language
  i18n.global.locale.value = to.params.lang as string;

  // Set document title
  document.title =
    typeof to.meta?.title === 'string' ? to.meta.title : 'FECHO-CAIXA';

  // Check if auth is required
  if (to.matched.some((route) => route.meta.requiresAuth)) {
    if (!store.getters.isLoggedIn || !token) {
      return next({ name: 'login', params: { lang: to.params.lang } });
    }

    // Check for specific role restriction
    const requiredRole = to.meta.role;
    const userRole = store.getters.userRole;
    console.log('roles', requiredRole, userRole);

    // Only restrict if meta.role is defined
    if (requiredRole && userRole !== requiredRole) {
      return next({ name: 'not-authorized', params: { lang: to.params.lang } });
    }

    return next();
  }

  return next();
});

// router.beforeEach(async (to, from, next) => {
//   // If no language param is set, redirect to the default language route
//   if (!to.params.lang) {
//     const defaultLanguage = process.env.VUE_APP_DEFAULT_LOCALE || 'pt';
//     return next({ name: 'locale', params: { lang: defaultLanguage } });
//   }

//   // Set the language in i18n to current param lang
//   i18n.global.locale.value = to.params.lang as string;

//   // Update the URL tab title
//   document.title =
//     typeof to.meta?.title === 'string' ? to.meta.title : 'FECHO-CAIXA';

//   // Check if the route requires authentication
//   const token = window.localStorage.getItem(AUTH_TOKEN);

//   if (to.matched.some((route) => route.meta.requiresAuth)) {
//     // console.log('auth place');
//     if (!store.getters.isLoggedIn) {
//       router.push({ name: 'login', params: { lang: to.params.lang } });
//     }

//     if (token) {
//       try {
//         return next();
//       } catch (error) {
//         const noInternet = window.navigator.onLine ? false : true;
//         if (noInternet) {
//           alert('No Internet Connection');
//           return next(false);
//         } else {
//           return next({ name: 'login', params: { lang: to.params.lang } });
//         }
//       }
//     }

//     return next({ name: 'login', params: { lang: to.params.lang } });
//   } else {
//     next();
//   }
// });

export default router;
